import { css } from '@emotion/core';
import { colors, Slide } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions/transition';
import { List } from 'immutable';
import { ClassAttributes, Component, ComponentType, createElement, SyntheticEvent } from 'react';

// import Snackbar from './Snackbar';
import FormattedSnackbar from '../FormattedSnackbar';

interface Props {
  errors: Error[];
  onRequestClose: (e: SyntheticEvent<HTMLElement>, err: Error) => void;
  className?: string;
}

interface State {
  snackbarProps: List<SnackbarProps>;
}

interface SnackbarProps {
  id: number;
  error: Error | any; // TODO: 型指定どうすれば
  open: boolean;
  transition: ComponentType<TransitionProps>;
}

class NonFatalErrorSnackbars extends Component<ClassAttributes<HTMLElement> & Props, State> {
  private lastErrorId: number;

  state: State = {
    snackbarProps: List(),
  };

  constructor(props: ClassAttributes<HTMLElement> & Props) {
    super(props);

    this.lastErrorId = 0;
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps: ClassAttributes<HTMLElement> & Props) {
    const added = List(
      nextProps.errors.reduce((whole, error) => {
        // added errors
        if (this.props.errors.indexOf(error) === -1) {
          this.lastErrorId += 1;

          return [
            ...whole,
            {
              id: this.lastErrorId,
              error,
              open: true,
              transition: (props: any) => <Slide direction="right" {...props} />,
            },
          ];
        }

        return whole;
      }, [] as SnackbarProps[]),
    );

    const existed = this.state.snackbarProps.map(entry => {
      // deleted errors
      if (nextProps.errors.indexOf(entry.error) === -1) {
        return { ...entry, open: false };
      }

      return entry;
    });

    this.setState({
      snackbarProps: existed.merge(added),
    });

    this.enqueueDeleteHiddenErrors();
  }

  shouldComponentUpdate(_: any, nextState: State) {
    return !this.state.snackbarProps.equals(nextState.snackbarProps);
  }

  render() {
    return this.state.snackbarProps
      .map(({ id, error, transition }) => {
        const raw = error.is_raw ? true : false;
        return (
          <FormattedSnackbar
            action="root.snackbar.close"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            message={error.message}
            onClickAction={e => this.props.onRequestClose(e, error)}
            onRequestClear={e => this.props.onRequestClose(e, error)}
            className={this.props.className}
            key={id}
            transition={transition}
            ContentProps={{
              classes: {
                root: css({ backgroundColor: colors.red[500] }).toString(),
              },
            }}
            buttonColor="inherit"
            raw={raw}
            error={!!error.message}
          />
        );
      })
      .toArray();
  }

  private enqueueDeleteHiddenErrors = () => {
    setTimeout(
      () =>
        this.setState({
          snackbarProps: this.state.snackbarProps.filter(({ open }) => open),
        }),
      500,
    );
  };
}

export default NonFatalErrorSnackbars;
